import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import PropTypes from 'prop-types';
import { getFaro } from 'flow/api-clients/faro-client';
import { withRouter } from 'react-router';
import ErrorBoundaryView from 'flow/components/error-boundary/ErrorBoundaryView';
import { addGeneralLogEntry } from 'flow/utils/browser-utils';
import { jsx as _jsx } from "react/jsx-runtime";
var ContentPaneErrorBoundary = /*#__PURE__*/function (_React$Component) {
  function ContentPaneErrorBoundary(props) {
    var _this;
    _classCallCheck(this, ContentPaneErrorBoundary);
    _this = _callSuper(this, ContentPaneErrorBoundary, [props]);
    _defineProperty(_this, "onRetry", function () {
      var history = _this.props.history;
      history.goBack();
    });
    _this.state = {
      hasError: false
    };
    return _this;
  }
  _inherits(ContentPaneErrorBoundary, _React$Component);
  return _createClass(ContentPaneErrorBoundary, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.hasError && prevState.hasError && this.props.location.pathname !== prevProps.location.pathname) {
        this.setState({
          hasError: false
        });
      }
    }
  }, {
    key: "componentDidCatch",
    value: function componentDidCatch(error, _info) {
      var _getFaro;
      (_getFaro = getFaro()) === null || _getFaro === void 0 || _getFaro.api.pushError(error, {
        context: {
          component: 'ContentPane',
          severity: 'critical'
        }
      });
      addGeneralLogEntry("Error reported: ".concat(error));
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.hasError) {
        return /*#__PURE__*/_jsx(ErrorBoundaryView, {
          onClick: this.onRetry
        });
      }
      return this.props.children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError() {
      return {
        hasError: true
      };
    }
  }]);
}(React.Component);
_defineProperty(ContentPaneErrorBoundary, "propTypes", {
  children: PropTypes.node.isRequired,
  history: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  location: PropTypes.object // eslint-disable-line react/forbid-prop-types
});
export default withRouter(ContentPaneErrorBoundary);